import axiosInstance from './axiosCreator';
import { HelpDocPage, HelpDocSection } from '../types/HelpDocs';

export const fetchHelpDocsTree = async (): Promise<HelpDocSection[]> => {
  const response = await axiosInstance.get('/api/v5/docs/tree');
  return response.data?.data?.sections || [];
};

export const fetchHelpDocBySlug = async (
  slug: string
): Promise<HelpDocPage | null> => {
  try {
    const response = await axiosInstance.get(`/api/v5/docs/${slug}`);
    return response.data?.data || null;
  } catch (error) {
    return null;
  }
};
